/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Fragment, useEffect, useMemo, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, } from '@fortawesome/pro-regular-svg-icons';
import { debounce } from 'lodash';
import { dayjs } from '../util/dayjs';
import { IconButton } from './IconButton';
import { Button } from './Button';
export var DayPicker = function (_a) {
    var className = _a.className, start = _a.start, onStartChange = _a.onStartChange, value = _a.value, onChange = _a.onChange, values = _a.values, numberOfDays = _a.numberOfDays, onNumberOfDaysChange = _a.onNumberOfDaysChange;
    var containerRef = useRef(null);
    useEffect(function () {
        var updateSize = function () {
            var _a;
            var width = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width;
            onNumberOfDaysChange(width ? Math.min(Math.floor((width - 80) / 60), 7) : 3);
        };
        var debouncedUpdateSize = debounce(updateSize, 500);
        window.addEventListener('resize', debouncedUpdateSize);
        updateSize();
        return function () {
            window.removeEventListener('resize', debouncedUpdateSize);
        };
    }, [onNumberOfDaysChange]);
    var days = useMemo(function () { return getDays(dayjs(start), numberOfDays); }, [numberOfDays, start]);
    useEffect(function () {
        var selected = days.find(function (day) { return day === value; });
        if (!selected) {
            onChange(days[0]);
        }
    }, [days, onChange, value]);
    return (jsx("div", { ref: containerRef, sx: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
        }, className: className },
        jsx(IconButton, { onClick: function () {
                onStartChange(dayjs(start).subtract(numberOfDays, 'days').format('YYYY-MM-DD'));
            }, disabled: start <= dayjs().format('YYYY-MM-DD') },
            jsx(FontAwesomeIcon, { icon: faChevronLeft })),
        days.map(function (day) {
            var _a;
            var selected = day === value;
            return (jsx(Button, { key: day, variant: "filledLightGrey", sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative',
                    p: 0,
                    width: 60,
                    height: 50,
                    lineHeight: 1,
                    marginBottom: 2,
                    bg: 'white',
                    borderRadius: 0,
                    borderStyle: 'solid',
                    borderBottomWidth: 3,
                    borderTopWidth: 0,
                    borderLeftWidth: 0,
                    borderRightWidth: 0,
                    borderColor: selected ? 'primary' : 'transparent',
                    color: selected ? 'primary' : 'text',
                }, onClick: function () {
                    onChange(day);
                } },
                jsx("div", { sx: { fontSize: 0, fontWeight: 'body', color: 'muted' } }, dayjs(day).format('ddd')),
                jsx("div", { sx: { fontSize: 1 } },
                    selected && (jsx(Fragment, null,
                        dayjs(day).format('MMM'),
                        "\u00A0")),
                    dayjs(day).format('D')),
                jsx(CountBubble, { count: values && ((_a = values[day]) === null || _a === void 0 ? void 0 : _a.length) })));
        }),
        jsx(IconButton, { onClick: function () {
                onStartChange(dayjs(start).add(numberOfDays, 'days').format('YYYY-MM-DD'));
            } },
            jsx(FontAwesomeIcon, { icon: faChevronRight }))));
};
function getDays(start, count) {
    var days = [];
    var day = start.startOf('day');
    for (var i = 0; i < count; i++) {
        days.push(day.format('YYYY-MM-DD'));
        day = day.add(1, 'day');
    }
    return days;
}
var CountBubble = function (_a) {
    var count = _a.count;
    return count ? (jsx("div", { sx: {
            lineHeight: '20px',
            width: 20,
            fontSize: 0,
            bg: 'primary',
            color: 'white',
            textAlign: 'center',
            position: 'absolute',
            left: 38,
            top: 0,
            zIndex: 1,
            borderRadius: '50%',
        } }, count)) : null;
};
//# sourceMappingURL=DayPicker.js.map